<template>
    <footer class="pt-6 pb-12 bg-white">
        <div class="px-4 mx-auto mb-8 max-w-screen-xl md:mb-16 sm:px-6 lg:px-8">
            <div class="w-full bg-[#ECECEC] h-[3px]">

            </div>
        </div>

        <div class="px-4 mx-auto max-w-screen-xl sm:px-6 lg:px-8">
            <div class="flex flex-col items-center">
                <!-- Logo -->
                <div class="mb-12">
                    <a href="https://lifeboostcoffee.com/" class="block">
                        <nuxt-img :src="logoSrc" alt="Lifeboost Coffee" class="w-auto h-16" loading="lazy" />
                    </a>
                </div>

                <!-- Contact Box -->
                <div class="overflow-hidden w-full rounded-lg border border-[#C6C6C6] max-w-3xl mx-auto">
                    <div class="py-4 text-center border-b border-gray-200 bg-[#E8E8E8]">
                        <h3 class="font-bold text-black font-ww-bold"
                            :class="newStyle ? 'text-xl' : 'md:text-xl text-lg'" v-html="title"></h3>
                    </div>

                    <div class="flex flex-col gap-4 justify-center items-center px-4 py-6 md:flex-row md:gap-6 lg:gap-12"
                        :class="newStyle ? 'md-max:gap-y-6' : ''">
                        <a :href="phoneLink" class="flex gap-2 items-center text-black transition-colors">
                            <svg width="19" height="19" viewBox="0 0 19 19" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M2.0129 1.87014H6.21129L7.56431 5.25324L5.39031 6.7026C5.26229 6.78802 5.15733 6.90371 5.08474 7.03943C5.01215 7.17514 4.97419 7.32667 4.97421 7.48058C4.97702 7.56847 4.97421 7.48151 4.97421 7.48151V7.50115C4.97468 7.54297 4.97655 7.58476 4.97982 7.62645C4.98481 7.70375 4.99572 7.80661 5.01255 7.93502C5.04902 8.18749 5.11915 8.53534 5.25566 8.9449C5.53057 9.76776 6.06916 10.8328 7.11829 11.882C8.16742 12.9311 9.23244 13.4697 10.0544 13.7446C10.4648 13.8811 10.8117 13.9503 11.0661 13.9877C11.2095 14.0086 11.3541 14.0211 11.499 14.0251L11.5112 14.0261H11.5186C11.5186 14.0261 11.6234 14.0205 11.5196 14.0261C11.6932 14.026 11.8633 13.9776 12.011 13.8862C12.1586 13.7949 12.2779 13.6643 12.3555 13.509L12.982 12.256L17.1299 12.9479V16.9875C15.156 17.2727 9.82433 17.5541 5.63529 13.365C1.44626 9.17586 1.72677 3.84315 2.0129 1.87014ZM6.91258 7.93502L8.60222 6.8092C8.95917 6.5711 9.22339 6.2175 9.35057 5.8077C9.47774 5.3979 9.46014 4.95683 9.3007 4.55848L7.94768 1.17539C7.80884 0.828385 7.56921 0.530948 7.2597 0.321442C6.9502 0.111937 6.58503 -2.50538e-05 6.21129 4.20523e-09H1.96428C1.11432 4.20523e-09 0.314846 0.590031 0.175523 1.51201C-0.142395 3.60844 -0.573454 9.80049 4.31313 14.6872C9.19971 19.5739 15.3916 19.1419 17.488 18.8249C18.41 18.6846 19 17.8861 19 17.0361V12.9479C19.0001 12.5052 18.8431 12.0769 18.557 11.7391C18.2709 11.4012 17.8742 11.1759 17.4375 11.103L13.2896 10.412C12.8951 10.3462 12.4899 10.4085 12.1335 10.59C11.777 10.7714 11.4881 11.0623 11.3092 11.42L10.9857 12.068C10.8713 12.0396 10.7581 12.0069 10.6462 11.9699C10.0665 11.7772 9.26143 11.3808 8.44045 10.5598C7.61948 9.73878 7.22301 8.93368 7.03039 8.353C6.98498 8.21556 6.94598 8.07608 6.91351 7.93502H6.91258Z"
                                    fill="black" />
                            </svg>

                            <span class="font-ww-regular" :class="newStyle ? 'text-xl' : 'text-lg lg:text-xl'"
                                v-html="phoneNumber"></span>
                        </a>

                        <button type="button" class="flex gap-2 items-center text-black transition-colors"
                            aria-label="Open live chat" @click="openLiveChat">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M1 9C1 6.87827 1.84285 4.84344 3.34315 3.34315C4.84344 1.84285 6.87827 1 9 1C11.1217 1 13.1566 1.84285 14.6569 3.34315C16.1571 4.84344 17 6.87827 17 9V14.09C17 14.938 17 15.36 16.874 15.699C16.7738 15.9676 16.617 16.2116 16.4143 16.4143C16.2116 16.617 15.9676 16.7738 15.699 16.874C15.36 17 14.937 17 14.09 17H9C6.87827 17 4.84344 16.1571 3.34315 14.6569C1.84285 13.1566 1 11.1217 1 9Z"
                                    stroke="black" stroke-width="2" />
                                <path d="M6 8H12M9 12H12" stroke="black" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                            <span class="font-ww-regular" :class="newStyle ? 'text-xl' : 'text-lg lg:text-xl'"
                                v-html="liveChatText"></span>
                        </button>

                        <a :href="emailLink" class="flex gap-2 items-center text-black transition-colors">
                            <svg class="mt-1" width="20" height="16" viewBox="0 0 20 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V13C0 13.7956 0.316071 14.5587 0.87868 15.1213C1.44129 15.6839 2.20435 16 3 16H17C17.7956 16 18.5587 15.6839 19.1213 15.1213C19.6839 14.5587 20 13.7956 20 13V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM16.33 2L10 6.75L3.67 2H16.33ZM17 14H3C2.73478 14 2.48043 13.8946 2.29289 13.7071C2.10536 13.5196 2 13.2652 2 13V3.25L9.4 8.8C9.5731 8.92982 9.78363 9 10 9C10.2164 9 10.4269 8.92982 10.6 8.8L18 3.25V13C18 13.2652 17.8946 13.5196 17.7071 13.7071C17.5196 13.8946 17.2652 14 17 14Z"
                                    fill="black" />
                            </svg>

                            <span class="font-ww-regular" :class="newStyle ? 'text-xl' : 'text-lg lg:text-xl'"
                                v-html="email"></span>
                        </a>
                    </div>
                </div>

                <!-- Copyright & Links -->
                <div class="flex flex-col gap-8 items-center mt-12 text-sm text-black md:flex-row font-ww-regular"
                    :class="newStyle ? 'md-max:gap-y-4 md-max:mt-6' : ''">
                    <div>© {{ currentYear }} {{ copyrightText }}</div>
                    <div class="flex gap-8"
                        :class="newStyle ? 'md-max:flex-col md-max:items-center md-max:gap-y-4' : ''">
                        <a :href="termsUrl" target="_blank" class="hover:underline" v-html="termsText"></a>
                        <a :href="privacyUrl" target="_blank" class="hover:underline" v-html="privacyText"></a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup>
const currentYear = new Date().getFullYear();

const props = defineProps({
    newStyle: { type: Boolean, default: false },
    logoSrc: { type: String, default: '/assets/images/logo-lifeboost-black.png' },
    title: { type: String, default: "Questions? We're Here to Help" },
    phoneNumber: { type: String, default: '1-800-479-1596' },
    phoneLink: { type: String, default: 'tel:1-800-479-1596' },
    liveChatText: { type: String, default: 'Live Chat' },
    email: { type: String, default: 'support@lifeboostcoffee.com' },
    emailLink: { type: String, default: 'mailto:support@lifeboostcoffee.com' },
    copyrightText: { type: String, default: 'Lifeboost Group Inc. All Rights Reserved.' },
    termsText: { type: String, default: 'Terms and Conditions' },
    termsUrl: { type: String, default: 'https://lifeboostcoffee.com/pages/terms-conditions' },
    privacyText: { type: String, default: 'Privacy Policy' },
    privacyUrl: { type: String, default: 'https://lifeboostcoffee.com/pages/privacy-policy' },
})

const openLiveChat = () => {
    // Gorgias chat is injected on the client; guard against SSR.
    if (typeof window === 'undefined' || typeof document === 'undefined') return;

    // Try known global APIs first (if present).
    const gorgias = window.GorgiasChat;
    if (gorgias && typeof gorgias.open === 'function') {
        gorgias.open();
        return;
    }

    // Fallback: click the embedded messenger button (iframe: #chat-button).
    const iframe = document.querySelector('iframe#chat-button');
    const iframeDoc = iframe?.contentDocument || iframe?.contentWindow?.document;
    const btn = iframeDoc?.getElementById('gorgias-chat-messenger-button');
    if (btn && typeof btn.click === 'function') {
        btn.click();
        return;
    }
};

defineBuilderComponent({
    friendlyName: 'Footer Contact Block',
    inputs: [
        { name: 'newStyle', type: 'boolean', defaultValue: false, friendlyName: 'New Style' },
        { name: 'logoSrc', type: 'file', friendlyName: 'Logo Image', defaultValue: '/assets/images/logo-lifeboost-black.png', allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'] },
        { name: 'title', type: 'text', friendlyName: 'Title', defaultValue: "Questions? We're Here to Help" },
        { name: 'phoneNumber', type: 'text', friendlyName: 'Phone Number Display', defaultValue: '1-800-479-1596' },
        { name: 'phoneLink', type: 'text', friendlyName: 'Phone Number Link (tel:...)', defaultValue: 'tel:1-800-479-1596' },
        { name: 'liveChatText', type: 'text', friendlyName: 'Live Chat Text', defaultValue: 'Live Chat' },
        { name: 'email', type: 'text', friendlyName: 'Email Display', defaultValue: 'support@lifeboostcoffee.com' },
        { name: 'emailLink', type: 'text', friendlyName: 'Email Link (mailto:...)', defaultValue: 'mailto:support@lifeboostcoffee.com' },
        { name: 'copyrightText', type: 'text', friendlyName: 'Copyright Text', defaultValue: 'Lifeboost Group Inc. All Rights Reserved.' },
        { name: 'termsText', type: 'text', friendlyName: 'Terms Link Text', defaultValue: 'Terms and Conditions' },
        { name: 'termsUrl', type: 'text', friendlyName: 'Terms Link URL', defaultValue: 'https://lifeboostcoffee.com/pages/terms-conditions' },
        { name: 'privacyText', type: 'text', friendlyName: 'Privacy Link Text', defaultValue: 'Privacy Policy' },
        { name: 'privacyUrl', type: 'text', friendlyName: 'Privacy Link URL', defaultValue: 'https://lifeboostcoffee.com/pages/privacy-policy' },
    ]
});
</script>
